/**
 * @desc js 小盾风控接入
 * @tdStorageTime 有效值缓存时间

 * 实际页面取值处理
 * localStorage.getItem('tongdunBlackBox') || '';
 */
import {
  IsKEWLApp
} from './uaInfo';
import { loadJs } from './utility';

// 全局挂载
if (!window.TONGDun) {
  window.TONGDun = {};
}
if (!window.TONGDun.time) {
  window.TONGDun.time = {};
}

// 拉取tongdun.js
export const loadTongdun = () => {
  loadJs('/app/js/dist/tongdun.js?v=202409051024');
};
// 获取storage存储的tongdunBlackBox值
export const getBlackBox = function () {
  const storageBlackBox = localStorage.getItem('tongdunBlackBox') || '';
  // 当前处理为只用有效值，不采用降级值
  if (storageBlackBox.length <= 1024) {
    return storageBlackBox;
  }
  return '';
};
// 尝试获取tongdunBlackBox，获取不到就拉取tongdun.js
export const tryLoadTongdun = () => {
  // 检测是否有tongdun.js，避免重复加载
  let flag = false;
  for (let index = 0; index < document.scripts.length; index += 1) {
    if (document.scripts[index].src && document.scripts[index].src.indexOf('/tongdun.js') > -1) {
      flag = true;
      break;
    }
  }
  if (flag) {
    return;
  }
  const tdStorageTime = 7 * 24 * 60 * 60 * 1000; // 缓存7天
  // const tdStorageTime = 60 * 60 * 1000; // 线上同盾异常，暂时只缓存1小时
  const tdCurTime = new Date().getTime(); // 当前时间
  const tdPrevTime = localStorage.getItem('tongdunAbleTime') || false; // 上次缓存时间
  // console.log(tdCurTime, tdPrevTime);
  const storageBlackBox = getBlackBox();
  if (!storageBlackBox || !tdPrevTime || (!!tdPrevTime && tdCurTime - Number(tdPrevTime) > tdStorageTime)) {
    loadTongdun();
  } else {
    const ableTime = new Date().getTime();
    window.TONGDun.time.ableTime = ableTime;
  }
};
// 清除缓存信息
export const clear = function () {
  localStorage.removeItem('tongdunAbleTime');
  localStorage.removeItem('tongdunBlackBox');
};
export const initAutoLoad = () => {
  // initTime只初始化一遍
  !window.TONGDun.time.initTime && (window.TONGDun.time.initTime = new Date().getTime());
  // app内通过getUserInfo获取td_black_box
  if (IsKEWLApp && window.KEWLApp && window.KEWLApp.getUserInfo) {
    window.KEWLApp.getUserInfo((data) => {
      const userInfo = typeof data === 'string' && data !== 'null' && data !== '' ? JSON.parse(data) : data;
      if (userInfo instanceof Object && userInfo.td_black_box) {
        window.TONGDun.time.ableTime = new Date().getTime();
        localStorage.setItem('tongdunAbleTime', window.TONGDun.time.ableTime);
        localStorage.setItem('tongdunBlackBox', userInfo.td_black_box);
      } else {
        tryLoadTongdun();
      }
    });
  } else {
    tryLoadTongdun();
  }
};
window.TONGDun.initAutoLoad = initAutoLoad;
window.TONGDun.loadTongdun = loadTongdun;
window.TONGDun.tryLoadTongdun = tryLoadTongdun;
window.TONGDun.clear = clear;
window.TONGDun.getBlackBox = getBlackBox;
initAutoLoad();
